import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useAuth } from "../../contexts/auth";
import { postOrdersURL, getSearchProductsURL } from "../../utils/api";
// Chakra imports
import {
    Box,
    Button,
    Flex,
    Icon,
    Spacer,
    Text,
    useColorModeValue,
    FormControl,
    FormLabel,
    Select,
    Input,
    Progress,
    Switch
} from "@chakra-ui/react";
import { Separator } from "components/Separator/Separator";
// react icons
import { BsArrowRight } from "react-icons/bs";
import useGetCustomers from "../../hooks/useGetCustomers";
import useGetServices from "../../hooks/useGetServices";


function SearchProduct({
    onClickProduct,
}) {


    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);

    const [ timer, setTimer     ] = useState(null);
    const [ searchedProducts, setSearchedProducts ] = useState([]);
    const [ searching, setSearching ] = useState(false);


    const changeDelay = (change) => {

        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                if (change == '') {
                    setSearchedProducts([]);
                    setSearching(false);
                } else {
                    postSearchProduct(change);
                }
            }, 1500)
        );
    }


    const postSearchProduct = (keyword) => {

        setSearching(true);
        // console.log(stock, price);
        axios.get(getSearchProductsURL, 
        {
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            },
            params: {
                keyword,
                limit: 15,
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const productResults = result.data.data;
                setSearchedProducts(productResults);
                // console.log(productResults);
            } else {
                // setErrors(result.data.errors);
            }
        }).catch(e => {
            // if (e.response === undefined) {
            //     setErrors(['Could not connect to server!'])
            // } else {
            //     setErrors(e.response.data.errors)
            // }
        }).finally(e => {
            setSearching(false);
        });
    }

    return (
        <FormControl marginBottom="12px">
            
            <Box pr="12px" w="100%">
                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                    Search Item
                </FormLabel>
                <Input
                    borderRadius="15px"
                    fontSize="sm"
                    type="text"
                    placeholder="Keyword"
                    size="md" 
                    onChange={(e) => { changeDelay(e.target.value) }}
                />
            </Box>
            <Flex flexDirection="column" w="98%"
                position={"absolute"}
                zIndex={searching || searchedProducts.length == 0 ? -1 : 99999} 
                backgroundColor="white" 
                maxHeight={200} 
                overflowY="auto" 
                borderColor={"gray"}
                borderWidth={1}
                borderRadius="5px" 
                paddingTop={2}
                marginRight={12}
                >
                {   searching 
                    ? <Progress isIndeterminate />
                    : searchedProducts.map((i) => {
                        return <Flex 
                            flexDirection="column" 
                            w="100%"
                            key={`searched-prods-${i.id}`}
                        >
                            <Text 
                                _hover={{
                                    cursor: "pointer"
                                }}
                                className="row" 
                                ml="12px" mr="12px" 
                                fontSize="xs" 
                                onClick={(e) => onClickProduct(i)} 
                                >
                                    + {i.name}  
                                    { i.carMake || i.carType || i.carYear || i.carPart 
                                        ? ` (${i.carMake ?? ""} ${i.carType ?? ""} ${i.carYear ?? ""}${i.carPart ? " Part No: " + i.carPart : ""})`
                                        : ""
                                    }
                            </Text>
                            <Text 
                                _hover={{
                                    cursor: "pointer"
                                }}
                                className="row" 
                                ml="24px" mr="12px" 
                                fontSize="xs" 
                                onClick={(e) => onClickProduct(i)} 
                                >
                                    {i.description}  
                            </Text>
                            <Flex flexDirection="row" 
                                w="100%" 
                                align={"center"} 
                                mt={"4px"}
                                >
                                <Text 
                                    fontSize="xs" 
                                    pl={"32px"}
                                    // color="gray.400" 
                                    key={`current-stocks-${i.id}`}
                                    >
                                    Current Stocks: {
                                        i.stocks && i.stocks.length > 0
                                        ? i.stocks.map(item => item.quantity).reduce((prev, next) => prev + next)
                                        : "0"
                                    } 
                                </Text>
                                &nbsp;&nbsp;
                                <Text 
                                    fontSize="xs" 
                                    pl={"32px"}
                                    // color="gray.400" 
                                    key={`current-selling-price-${i.id}`}
                                    >
                                    Selling Price: {
                                        i.stocks && i.stocks.length > 0
                                        ? i.stocks[0].sellingPrice
                                        : "0"
                                    } 
                                </Text>
                            </Flex>
                            <Separator />
                        </Flex>
                    })
                }
            </Flex>
        </FormControl>
    );
}

export default SearchProduct;